export const darkBlue = "#126BA5";
export const buttonsLigthBlue = "#52B6FF";
export const ligthGreen = "#8FC549";
export const backgroundGray = "#EBEBEB";